import { render } from "./SendMessage.vue?vue&type=template&id=f21bd8d2&scoped=true"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"

import "./SendMessage.scss?vue&type=style&index=0&id=f21bd8d2&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21bd8d2"]])

export default __exports__